<mat-card class="lt-filter-container">
    <mat-card-header [style]="{ display: showHeader() ? 'flex' : 'none' }">
        <mat-card-title>Filter</mat-card-title>
        <div class="header-actions ms-auto">
            <button matButton (click)="addFilter()" color="primary">
                <mat-icon>add</mat-icon>
                Add Filter
            </button>
            <button matButton (click)="clearAll()" [disabled]="filterRows().length === 0">
                <mat-icon>clear</mat-icon>
                Clear All
            </button>
            <button matButton="elevated" (click)="applyFilter()" [disabled]="!hasValidFilters()">
                Apply
            </button>
        </div>
    </mat-card-header>

    <mat-card-content>
        @if (filterRows().length === 0) {
            <div class="empty-state">
                <mat-icon class="empty-state-icon">
                    filter_list
                </mat-icon>
                <p>No filters applied</p>
                <button matButton color="primary" (click)="addFilter()">
                    Add your first filter
                </button>
            </div>
        } @else {
            <!-- Root Logic Selector (only show when multiple filters) -->
            @if (filterRows().length > 1) {
                <div class="root-logic mb-3">
                    <mat-form-field appearance="outline" class="filter-form-field">
                        <mat-label>Join with</mat-label>
                        <mat-select [value]="rootLogic()" (selectionChange)="setRootLogic($event.value)">
                            <mat-option value="and">AND</mat-option>
                            <mat-option value="or">OR</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            }

            <!-- Filter Rows -->
            <div class="lt-filter-rows d-flex flex-column">
                @for (row of filterRows(); track row.id; let i = $index) {
                    <div>
                        @if (i > 0) {
                            <mat-divider class="mb-3"></mat-divider>
                        }
                        <app-lt-filter-row
                            [filter]="row.filter"
                            [columns]="columns()"
                            [logic]="row.logic"
                            [showLogic]="i > 0"
                            (filterChange)="updateFilter(row.id, $event)"
                            (logicChange)="updateLogic(row.id, $event)"
                            (remove)="removeFilter(row.id)">
                        </app-lt-filter-row>
                    </div>
                }
            </div>

            <!-- Add Filter Button -->
            <div class="add-filter text-align-center mt-3">
                <button matButton (click)="addFilter()" color="primary">
                    <mat-icon>add</mat-icon>
                    Add Filter
                </button>
            </div>
        }
    </mat-card-content>

    <!-- Actions Footer -->
    <mat-card-actions align="end" [style]="{ display: showActions() ? 'flex' : 'none' }">
        <button matButton (click)="cancelFilter()">Cancel</button>
        <button matButton="elevated" color="primary" (click)="applyFilter()" [disabled]="!hasValidFilters()">
            Apply Filter
        </button>
    </mat-card-actions>
</mat-card>